import { useMutation } from "react-query";
import * as web from "services/webServices/webServices";

export const useNewsLetter = () => {
  return useMutation((formData) => web.newsLetter(formData));
};
